import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  CardContent,
  CardHeader,
  Divider,
  ExpansionPanel,
  ExpansionPanelDetails,
  Grid,
  TextField,
  useTheme,
  Card
} from '@material-ui/core';
import { ServiceValues } from '../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../services/ServiceEW';
import moment from 'moment';
import CardTotalizacao from '../../../../components/CardTotalizacao';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import DetalhesFiliado from './DetalhesFiliado';
import DetalhesModalidades from './DetalhesModalidades';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useStyles } from '../../../VisitaFiliadoRegisterDetalhado/components/VisitaFiliadoRegisterDetalhadoPasso2/ModalidadeGeral/ModalidadeGeralStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import clsx from 'clsx';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import FingerprintIcon from '@material-ui/icons/Fingerprint';

function VisitaFiliadoVisualizacaoDetalhes(props) {
  const {
    visitaFiliado,
    setVisitaFiliado,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    edicao,
    history,
    modalidades,
    armas,
    insumos,
    pacotes
  } = props;
  const [qtdDisparos, setQtdDisparos] = useState(0);
  const [valorDesconto, setValorDesconto] = useState(0);
  const [valorTotal, setValorTotal] = useState(0);
  const [expandedInsumosAdicionais, setExpandedInsumosAdicionais] = useState();
  const theme = useTheme();
  const classes = useStyles();

  useEffect(() => {
    getQtdDisparos();
    getValorDesconto();
    getValorTotal();
  }, []);

  function getQtdDisparos() {
    let total = 0;
    for (let i = 0; i < visitaFiliado.visitaFiliadoMods.length; i++) {
      total +=
        visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[0].quantidade;
    }
    setQtdDisparos(total);
  }

  function getValorDesconto() {
    let total = 0;
    for (let i = 0; i < visitaFiliado.visitaFiliadoMods.length; i++) {
      total +=
        visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[0].desconto;
    }
    setValorDesconto(total);
  }

  function getValorTotal() {
    setValorTotal(visitaFiliado ? visitaFiliado.valorTotal : 0);
  }

  const changeExpansionPanel = panel => (event, isExpanded) => {
    setExpandedInsumosAdicionais(isExpanded ? panel : false);
  };

  return (
    <div>
      <CardHeader
        subheader={
          'Todas as informações referentes a visita do dia ' +
          moment(visitaFiliado.dataEntrada).format('DD/MM/YYYY') +
          ' de ' +
          visitaFiliado.filiado.nome
        }
        title="Detalhes da visita."
      />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item md={3} sm={6} xs={12}>
            <CardTotalizacao
              backgroundColorIcon={theme.palette.info.main}
              icon={'PlaylistAddCheckIcon'}
              title="SUBTOTAL"
              value={(visitaFiliado.subtotal
                ? visitaFiliado.subtotal
                : 0
              ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            />
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <CardTotalizacao
              backgroundColorIcon={theme.palette.warning.main}
              icon={'AddShoppingCartIcon'}
              title="INSUMOS ADICIONAIS"
              value={(visitaFiliado.valorInsumoAdicional
                ? visitaFiliado.valorInsumoAdicional
                : 0
              ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            />
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <CardTotalizacao
              backgroundColorIcon={theme.palette.success.main}
              icon={'TrendingDownIcon'}
              title="DESCONTO"
              value={(visitaFiliado.descontoTotal
                ? visitaFiliado.descontoTotal
                : 0
              ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            />
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <CardTotalizacao
              backgroundColorIcon={theme.palette.white}
              colorIcon={theme.palette.primary.main}
              icon={'AttachMoneyIcon'}
              title="TOTAL"
              value={(visitaFiliado.valorTotal
                ? visitaFiliado.valorTotal
                : 0
              ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              backgroundColorCard={theme.palette.primary.main}
              colorCard={theme.palette.primary.contrastText}
              colorText="inherit"
            />
          </Grid>
          <Grid item md={12}>
            <Grid item xs={12} sm={12} md={12}>
              <Card>
                <CardContent>
                  <Grid container>
                    <Grid item>
                      <Avatar
                        style={{
                          backgroundColor: visitaFiliado.startedFingerprint
                            ? '#22bb33'
                            : '#bb2124'
                        }}>
                        {<FingerprintIcon />}
                      </Avatar>
                    </Grid>
                    <Grid
                      item
                      style={{
                        marginLeft: 16,
                        textAlign: 'center',
                        justifySelf: 'center',
                        alignSelf: 'center'
                      }}>
                      <Typography variant="h3">
                        {visitaFiliado.startedFingerprint
                          ? `Digital capturada`
                          : 'Digital não capturada'}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid item md={12} xs={12}>
            <DetalhesFiliado visitaFiliado={visitaFiliado} />
          </Grid>
          <Grid item md={12} xs={12}>
            <ExpansionPanel>
              <ExpansionPanelDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12}>
                    <DetalhesModalidades
                      setShowMessageSnack={setShowMessageSnack}
                      setMessageSnack={setMessageSnack}
                      setTypeSnack={setTypeSnack}
                      setLoading={setLoading}
                      visitaFiliado={visitaFiliado}
                      setVisitaFiliado={setVisitaFiliado}
                      modalidades={modalidades}
                      armas={armas}
                      insumos={insumos}
                      pacotes={pacotes}
                    />
                  </Grid>
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <ExpansionPanel
                  expanded={expandedInsumosAdicionais === 'panel1'}
                  onChange={changeExpansionPanel('panel1')}
                  variant={'elevation'}
                  style={{
                    marginTop: 25
                  }}>
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header">
                    <Typography className={classes.heading}>
                      <b>{'Insumos adicionais'}</b>
                    </Typography>
                  </ExpansionPanelSummary>

                  <ExpansionPanelDetails>
                    <List dense>
                      {visitaFiliado.insumosAdicionais.map(
                        (insumoAdicional, index) => {
                          return (
                            <Grid container spacing={2}>
                              <Grid item md={12} xs={12}>
                                <ListItem>
                                  <ListItemAvatar>
                                    <Avatar>
                                      <DoubleArrowIcon />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={
                                      <Grid container spacing={0}>
                                        <Grid item md={12} xs={12}>
                                          <Typography
                                            variant="h6"
                                            color="textPrimary"
                                            gutterBottom
                                            className={clsx({
                                              [classes.textoPrimarioItens]: true
                                            })}>
                                            {`Insumo: ${insumoAdicional.insumo.descricao}`}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    }
                                    secondary={
                                      <Grid container spacing={0}>
                                        <Grid item md={12} xs={12}>
                                          <Grid container>
                                            <Grid item md={12} xs={12}>
                                              {`Quantidade: ${insumoAdicional.quantidade}`}
                                            </Grid>
                                          </Grid>
                                          {'Total: R$ ' +
                                            (
                                              parseFloat(
                                                insumoAdicional.insumo
                                                  .valorVenda
                                              ) * insumoAdicional.quantidade
                                            ).toFixed(2)}
                                        </Grid>
                                      </Grid>
                                    }
                                  />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                              </Grid>
                            </Grid>
                          );
                        }
                      )}
                    </List>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
    </div>
  );
}

VisitaFiliadoVisualizacaoDetalhes.propTypes = {
  className: PropTypes.string,
  visitaFiliado: PropTypes.object.isRequired,
  setVisitaFiliado: PropTypes.object.isRequired
};

export default VisitaFiliadoVisualizacaoDetalhes;
